import { setOffersSelectionSucceed, setOffersSelectionPending, setOffersSelectionFailed } from './actions';
import { trackOffersLoad } from './tracking';
import { OFFERS_FOR_REQUEST_LIMIT } from '../../constants/offersSelectionLimits';
import { ETabType } from '../../repositories/chats/v1/get-my-offers-for-selection-desktop';
import { currentChatOpponentIdSelector, currentOpenChatIDSelector } from '../../selectors';
import { offersForSelection } from '../../selectors/offersForSelection';
import { fetchOffersForSelection } from '../../services/fetchOffersForSelection';
import { ERequestApiStatus } from '../../types/appState';
import { TThunkAction } from '../../types/redux/thunk';

/**
 * Получить список объявок для пикера
 */
export const getOffersForSelection =
  ({ tabType }: { tabType: ETabType }): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const state = getState();

    const { page, status, canLoadMore } = offersForSelection(state);
    const chatId = currentOpenChatIDSelector(state) || '';
    const opponentId = currentChatOpponentIdSelector(state);

    if (status === ERequestApiStatus.Pending || !canLoadMore) {
      return;
    }

    dispatch(setOffersSelectionPending());

    const {
      offers,
      statusCode,
      page: pageData,
    } = await fetchOffersForSelection(context, {
      parameters: {
        limit: OFFERS_FOR_REQUEST_LIMIT,
        offset: page * OFFERS_FOR_REQUEST_LIMIT,
        tabType,
      },
    });

    if (statusCode !== 200) {
      dispatch(setOffersSelectionFailed());

      return;
    }

    const baseDecimalOfferPosition = page * OFFERS_FOR_REQUEST_LIMIT;
    const preparedForTrackingData = offers.map(({ realtyOfferId }, index) => ({
      id: realtyOfferId,
      offerType: 'offer',
      position: baseDecimalOfferPosition + index + 1, // позиция объявки для пользователя начинается с 1
    }));

    trackOffersLoad({
      chatId,
      pageNumber: page + 1, // аналогично позиции объявления на странице
      products: preparedForTrackingData,
      dealType: tabType,
      opponentId,
    });

    dispatch(
      setOffersSelectionSucceed({
        list: offers,
        page: page + 1,
        canLoadMore: pageData?.canLoadMore,
      }),
    );
  };
